import React, { useEffect, useLayoutEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from "./AuthContext";
import ProtectedRoute from "./ProtectedRoute";

import AdminCategories from "./admin/Categories";
import AdminBusinesses from "./admin/Businesses";

import Services from './Services/Services';
import ServiceDetail from './Services/ServiceDetail';
import Destination from './Destination/Destination';
import Destination2 from './Destination/Destination2';
import Home2 from './Home2/Home2';
import Home3 from './Home3/Home3';
import Contact from './Contact/Contact';
import Connect from './Connect/Connect';
import Home from './Home/Home';
import Login from "./Auth/Login/Login";
import Signup from "./Auth/Signup/Signup";
import Dashboard from "./../src/Dashboard/Dashboard";
import IslandPage from './IslandPage/IslandPage';
import Hubmap from './Components/HubMap/HubMap';
import Directory from './Directory/Directory';
import ConnectAccess from './Connect/ConnectAccess';
import BusinessPage from "./Businesses/BusinessPage";

//admin only remove
import AddCategoryToBusiness from './admin/DatabseUploadPages/AddCategoryToBusiness'

function resetScrollPosition() {
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const previousScrollRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = 'manual';

    return () => {
      window.history.scrollRestoration = previousScrollRestoration;
    };
  }, []);

  useLayoutEffect(() => {
    resetScrollPosition();

    const frameId = window.requestAnimationFrame(() => {
      resetScrollPosition();
    });

    return () => window.cancelAnimationFrame(frameId);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <Routes>

          {/* Remove */}
          <Route path="/admin/add-category" element={<AddCategoryToBusiness />} />



          {/* Public pages */}
          <Route path="/" element={<Home2 />} />
          <Route path="/services" element={<Services />} />
          <Route path="/destinations-and-itineraries" element={<ServiceDetail serviceSlug="destination-itineraries-caribbean-support" />} />
          <Route path="/services/destination-itineraries-caribbean-support" element={<Navigate to="/destinations-and-itineraries" replace />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          {/* <Route path="/destinations" element={<Destination />} />
          <Route path="/destinations2" element={<Destination2 />} /> */}

          <Route path="/Home2" element={<Home2 />} />
          {/* <Route path="/Home3" element={<Home3 />} />
          <Route path="/Home" element={<Home />} /> */}
          <Route path="/contact" element={<Contact />} />
          <Route path="/connect" element={<ConnectAccess><Connect /></ConnectAccess>} />

          {/* Island Pages  */}
          <Route path="/destinations/:slug" element={<IslandPage />} />

          <Route path="/hubmap" element={<Hubmap />} />

          {/* Auth pages */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />

          {/* CMS Public pages */}
          <Route path="/directory" element={<ConnectAccess pageName="Directory"><Directory /></ConnectAccess>} />
         <Route path="/business/:id" element={<BusinessPage />} />

          {/* Protected pages */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          {/* Admin-only */}
          <Route
            path="/admin/categories"
            element={
              <ProtectedRoute requireAdmin={true}>
                <AdminCategories />
              </ProtectedRoute>
            }
          />
           <Route
            path="/admin/businesses"
            element={
              <ProtectedRoute requireAdmin={true}>
                <AdminBusinesses />
              </ProtectedRoute>
            }
          />
         <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
